import { render, staticRenderFns } from "./RelationConfig.vue?vue&type=template&id=91136b5a&scoped=true&"
import script from "./RelationConfig.vue?vue&type=script&lang=js&"
export * from "./RelationConfig.vue?vue&type=script&lang=js&"
import style0 from "./RelationConfig.vue?vue&type=style&index=0&id=91136b5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91136b5a",
  null
  
)

export default component.exports